<script lang="ts">
  import { pop } from "svelte-spa-router";
  import ListNavigationItem from "$shared/components/ListNavigationItem.svelte";
  import Separator from "$shared/components/Separator.svelte";
  import CardInline from "$shared/components/CardInline.svelte";
  import { onMount } from "svelte";
  import type { SpotShare } from "../../../apis/parkito2";
  import { formatDate } from "$shared/utils/dateTime";
  import { myPages } from "../stores/myPagesData.svelte.ts";

  type Props = { params: { id: string; spotid: string } };
  const { params }: Props = $props();
  const myPagesData = $derived($myPages.call.data);
  const spotShare: SpotShare | undefined = $derived(
    myPagesData?.findSpotShareForSpot(params.spotid),
  );
  const agreement = $derived(
    myPagesData?.findAgreementBySpot(params.spotid)?.agreement,
  );

  onMount(() => {
    if (import.meta.env.DEV) {
      console.log("SharedSpot mounted. Spot-id: " + params?.spotid);
    }
  });
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      onclick={pop}
      class="-ml-[8px]"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Plats {spotShare?.spot.name ?? "-"}
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="w-full min-[840px]:columns-2 columns-1 p-[24px] max-mobile:px-[8px]"
  >
    <CardInline title="Platsinformation">
      <ListNavigationItem
        title="Namn"
        textRight={spotShare?.spot.name ?? "-"}
        isFirst={true}
      />
      <ListNavigationItem
        title="Plats"
        textRight={spotShare?.spot.numeric_name.toString()}
      />
      <ListNavigationItem
        title="Giltighet"
        textRight={spotShare?.validUntil
          ? `Till och med ${
            formatDate(spotShare.validUntil, "YYYY-MM-DD")
          }`
          : "Tills vidare"}
      />
      <ListNavigationItem
        title="Typ"
        textRight={agreement?.translateProductKind()}
        isLast={true}
      />
    </CardInline>
  </div>
</div>
